<template>
<v-container fluid class="pa-0">
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
    <v-card-title >
        {{ (item.id) ? 'Fiche de ' + item.lastName + ' ' + item.firstName : 'Nouvel utilisateur' }}
        <v-spacer></v-spacer>
        <v-chip outlined color="secondary">
                <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.updatedAt).format('DD MMMM YYYY') }}
        </v-chip>
    </v-card-title>
    <v-form ref="form" v-model="validForm" lazy-validation>
    <v-row no-gutters>
    <v-col cols="12" md="4" class="pr-2">
        <v-text-field :rules="nameRules" autocomplete="off" outlined dense class="rounded-lg" label="Nom"    v-model="item.lastName" ></v-text-field>
        <v-text-field :rules="nameRules" autocomplete="off" outlined dense class="rounded-lg" label="Prénom" v-model="item.firstName"></v-text-field>
        <v-text-field autocomplete="off" outlined dense class="rounded-lg" label="Login"  v-model="item.username" :disabled="!$root.$permissions?.User?.before"></v-text-field>
        <v-text-field autocomplete="off" outlined dense class="rounded-lg" label="Mot de passe" type="password" v-model="item.password" loading>
            <template v-slot:progress>
                <v-progress-linear :value="progress" :color="color" height="3" absolute></v-progress-linear>
            </template>
        </v-text-field>
    </v-col>
    <v-col cols="12" md="4" class="pr-2">
        <v-text-field autocomplete="off" outlined dense class="rounded-lg" label="Tel" v-model="item.phone"></v-text-field>
        <v-text-field autocomplete="off" outlined dense class="rounded-lg" label="Mobile" v-model="item.mobile"></v-text-field>
        <v-text-field :rules="emailRules" autocomplete="off" outlined dense class="rounded-lg" label="Courriel" v-model="item.email"></v-text-field>
        <v-select v-if="$root.$permissions?.User?.update" 
            outlined dense class="" :items="roleList" item-value="value" v-model="item.role" label="Role" single-line >
        </v-select>
    </v-col>
    <v-col cols="12" md="4" class="pr-2">
        <v-btn v-if="$root.$permissions?.User?.update"  outlined color="primmary" class="mt-3 mb-3" @click="resetPasswordMail()">
            <v-icon left>mdi-mail</v-icon>Envoyer un mail de réinitialisation de mot de passe
        </v-btn>
        <v-btn v-if="$root.$permissions?.User?.update"  outlined color="primmary" class="mt-3 mb-3" @click="sendMagicLinkToUser()">
            <v-icon left>mdi-cellphone-message</v-icon>Envoyer un lien de connexion
        </v-btn>
        <v-alert dense border="left" type="success" v-for="item in roleSelected?.description" :key="item.id">
            <strong>- </strong> {{item}}
        </v-alert>
    </v-col>
    <v-col cols="12" md="4" class="pr-2"></v-col>
    <v-col cols="12" md="4" class="pr-2">
        <AutocompleteMulti v-if="!loading.fetchData"
            :title="'Société'"
            :listObject.sync="item.companyId" :listParent.sync="listCompanies" 
            ressource="companies"
            :fields="{ 
                index: 'cpy_id', text:'cpy_name', autofocus: true, outlined: true, dense: true,
                search:'cpy_name', multiSelect:false, prefetch: false, params:'extended=viewall'
        }"></AutocompleteMulti>
    </v-col>
    </v-row>
    </v-form>
    <v-card-actions>
        <v-btn class="rounded-xl" large color="red" v-if="item.uid" @click="deleteUser(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveUser()" :disabled="!validForm">Enregistrer</v-btn>
        <v-btn class="rounded-xl" large color="primmary" href="/#/users/">Retour</v-btn>
    </v-card-actions>
</v-card>
</v-container>
</template>

<script>
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import { mapState, mapActions } from 'pinia'
import { useUserStore } from '@/stores/user'
import { cacheGetters } from "@/stores/cache.module"

export default {
    name: 'User-Edit',
    components: { AutocompleteMulti },
    computed: {
        ...mapState(useUserStore, {item: 'item', roleList: 'getAuthorizedRolesArray', me: 'me' }),
        progress () {
            return (this.item.password) ? Math.min(100, this.item.password.length * 12.5) : 0
        },
        color () {
            return ['error', 'warning', 'success'][Math.floor(this.progress / 50)]
        },
        roleSelected (){
            return this.roleList.find(role => role.value === this.item.role)
        }
    },
    data: function () {
        return {
            loading: { fetchData: true },
            cacheState: cacheGetters.getStates('GEN') || [],
            listCompanies: [],
            validForm: true,
            nameRules: [ v => !!v || 'Le champ doit être renseigné', v => (v && v.length <= 100) || 'Doit être inférieur à 100 charactères', ],
            emailRules: [ v => !!v || 'E-mail requis', v => /.+@.+\..+/.test(v) || 'E-mail doit être valide', ],
        }
    },
    async beforeMount () {
        this.listCompanies.push( this.me.usercompany )
        await this.fetchUser( this.$route.params.id, '?include=usercompany' )
        if( !this.item.id ){
            this.item.companyId = this.me.companyId
            this.item.email = (this.me.usercompany.cpy_mail) ? Date.now() + this.me.usercompany.cpy_mail.slice(this.me.usercompany.cpy_mail.indexOf('@') ) : ''
            if( !this.item.email ){
                this.item.email = (this.me.email) ? Date.now() + this.me.email.slice(this.me.email.indexOf('@') ) : ''    
            }
        }
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useUserStore, {fetchUser: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', destroyItem: 'destroyItem', resetPassword: 'resetPassword', sendMagicLink: 'sendMagicLink'}),
        async saveUser () {
            await this.$refs.form.validate()
            if( this.validForm ){
                // Enregistrement du formulaire
                this.loading.fetchData = true
                try {
                    if( parseInt( this.$route.params.id ) > 0 ){
                        await this.updateItem()
                    } else {
                        await this.storeItem()
                    }
                    this.$router.push('users')
                } catch (error) {
                    this.$root.$toast({ timeout: 4000, color: 'error', text: error?.response?.data?.message })
                }

                this.loading.fetchData = false
            }
        },
        async resetPasswordMail(){
            await this.resetPassword( this.item.id )
            this.$root.$toast({ color: 'success', text: 'Mail envoyé !' })
        },
        async sendMagicLinkToUser(){
            await this.sendMagicLink( this.item.id, this.item.email )
            this.$root.$toast({ color: 'success', text: 'Mail / SMS envoyé !' })
        },
        async deleteUser(){
            this.$root.$confirm('Supprimer', 'Confirmer la suppression ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm ){
                    this.destroyItem()
                    this.$root.$toast({ color: 'error', top:false, bottom:true, right:false, left:true, text:'Utilisateur supprimée !' })
                    this.$router.push({ path: this.$route.fullPath.split('/').slice(0, -1).join('/') })
                }
            })
        },
        getCacheType: cacheGetters.getTypes,
    }
}
</script>